import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-18/task-03";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "The figure below shows the impedances of a full range driver, a woofer, a midrange driver<br>and a tweeter. Using the above order, indicate to which loudspeakers the impedances in the<br>graph correspond (e.g. adbc).",
  description: "Drag and drop elements. ",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/18/task/task-3.svg`,
                },
              },
              styles: {
                padding: "2%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
